<template>
  <b-card no-body class="monitoring-card">
    <b-card-header class="monitoring-header">
      <div class="header-title">
        <i class="fas fa-eye mr-2"></i>
        <strong>Acompanhamento Externo</strong>
      </div>
      <div class="header-actions">
        <b-button
          v-if="canEdit"
          :disabled="loadingMonitorings"
          variant="primary"
          size="sm"
          @click="$emit('open')"
        >
          <i class="fas fa-plus mr-1"></i>
          Inserir
        </b-button>
      </div>
    </b-card-header>
    <b-card-body class="monitoring-body">
      <div v-if="canEdit" class="response-toggle">
        <b-button
          :disabled="loadingMonitorings"
          variant="secondary"
          size="sm"
          @click="$emit('toggle-response', ombudsman)"
        >
          <template v-if="ombudsman.monitoringResponseEnabled">
            <i class="fas fa-toggle-off mr-1"></i>
            Desabilitar Resposta
          </template>
          <template v-else>
            <i class="fas fa-toggle-on mr-1"></i>
            Habilitar Resposta
          </template>
        </b-button>
      </div>

      <div v-if="loadingMonitorings" class="loading-container">
        <b-spinner></b-spinner>
        <span class="ml-2">Carregando...</span>
      </div>
      <div v-else-if="monitorings.length === 0" class="empty-container">
        <i class="fas fa-eye-slash fa-2x text-muted"></i>
        <p class="mt-2 text-muted">Nenhum acompanhamento encontrado</p>
      </div>
      <div v-else class="monitorings-container">
        <b-card
          v-for="monitoring in monitorings"
          :key="monitoring._id"
          :class="{ 'text-secondary': monitoring.hidden }"
          class="monitoring-item"
        >
          <b-card-body class="monitoring-item-body">
            <div class="monitoring-header-info">
              <div class="monitoring-date">
                <i class="fa fa-calendar-alt" aria-hidden="true" />
                {{ monitoring.createdAt | datetime }}
              </div>
              <div
                v-if="monitoring.type !== OmbudsmanMonitoringType.RESPONSE"
                class="monitoring-visibility"
              >
                <b-button
                  v-if="canEdit"
                  size="sm"
                  variant="link"
                  class="text-dark visibility-toggle"
                  :title="monitoring.hidden ? 'Exibir' : 'Ocultar'"
                  @click="$emit('toggle-visibility', monitoring)"
                >
                  <i
                    class="fa"
                    :class="{
                      'fa-eye': !monitoring.hidden,
                      'fa-eye-slash': monitoring.hidden,
                    }"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </div>

            <div
              v-if="monitoring.type !== OmbudsmanMonitoringType.RESPONSE"
              class="monitoring-user"
            >
              <template v-if="companyUsers[monitoring.user]">
                <i class="fa fa-user" aria-hidden="true"></i>
                {{ companyUsers[monitoring.user].name }}
                {{ companyUsers[monitoring.user].surname }}
              </template>
              <template v-else-if="managedByCompanyUsers[monitoring.user]">
                <i class="fa fa-user-tie" aria-hidden="true"></i>
                {{ managedByCompanyUsers[monitoring.user].name }}
                {{ managedByCompanyUsers[monitoring.user].surname }}
              </template>
              <template v-else>
                <i class="fa fa-user-tie text-info" aria-hidden="true"></i>
                {{ conformitaUsers[monitoring.user].name }}
                {{ conformitaUsers[monitoring.user].surname }}
              </template>
            </div>

            <div
              v-if="monitoring.type === OmbudsmanMonitoringType.COMPANY"
              class="monitoring-description"
            >
              {{ monitoring.description }}
            </div>

            <div
              v-else-if="monitoring.type === OmbudsmanMonitoringType.RESPONSE"
              class="monitoring-response"
            >
              <i class="fas fa-reply" aria-hidden="true" />
              {{ monitoring.response.text }}
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import OmbudsmanMonitoringType from "../../../../../backend/models/ombudsman/OmbudsmanMonitoringType.ts";

export default {
  name: "MonitoringCard",
  props: {
    ombudsman: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    loadingMonitorings: {
      type: Boolean,
      default: false,
    },
    monitorings: {
      type: Array,
      default: () => [],
    },
    companyUsers: {
      type: Object,
      default: () => ({}),
    },
    managedByCompanyUsers: {
      type: Object,
      default: () => ({}),
    },
    conformitaUsers: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      OmbudsmanMonitoringType,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
